<template>
  <div class="replaceProductItem-css">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">{{ $t('productAdded.myQuotation') }}</el-breadcrumb-item>
        <el-breadcrumb-item><a @click="toSecond"> {{ $t('productAdded.productConfigurationGroup') }}</a></el-breadcrumb-item>
        <el-breadcrumb-item><a @click="selectProduct"> {{ $t('productAdded.productAdded') }}</a></el-breadcrumb-item>
        <el-breadcrumb-item> {{ $t('productAdded.replaceProduct') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div ref="headtap">
      <div class="select-option">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form
              ref="formInline"
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
              @submit.native.prevent
              @keyup.enter.native="searchByKeyWords"
            >
              <el-form-item
                :label="$t('productAdded.needReplaceProduct')"
              >  
                {{ productName }}
              </el-form-item>
              <el-form-item
                prop="keyWords"
                style="padding: 0 0 0 20px;"
                v-if="propertyCode==='1001' ||
                  propertyCode==='1007'"
                :label="$t('productAdded.otherHost')"
              >
                <el-input
                  style="width:240px"
                  v-model="formInline.keyWords"
                  :placeholder="$t('productAdded.enterProductModel')"
                />
              </el-form-item>
              <el-form-item prop="userCollection" style="margin: 0 20px">
                <el-checkbox
                  v-model="formInline.userCollection"
                  true-label="userCollection"
                  false-label=""
                  @change="searchByKeyWords"
                >
                  {{ $t('productAdded.myFavorite') }}
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="searchByKeyWords"
                >
                  {{ $t('productAdded.select') }}
                </el-button>
                <el-button
                  @click="resetForm('formInline')"
                >
                  {{ $t('addConfigModule.reset') }}
                </el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <el-button
                  style="float: right"
                  type="primary"
                  @click="selectProduct"
                >
                  {{ $t('productAdded.back') }}
                </el-button>
              </el-form-item>
              <div class="clear" />
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="clear" />
    </div>
    <div class="table-select" ref="headtable">
      <el-table
        :data="tableData3"
        v-loading="loading3"
        :element-loading-text="$t('productAdded.tryMyBestLoading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
        :header-cell-style="{'text-align': 'left',background:'#eef1f6' }"
        border
        :stripe="true"
        style="width: 100%"
      >
        <el-table-column
          prop="productName"
          :label="$t('productAdded.productModel')"
          min-width="20%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductNameFormation :scope="scope" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('productAdded.productDes')"
          align="left"
          min-width="31%"
        >
          <template slot-scope="scope">
            <long-text :text="scope.row.productDesc" />
          </template>
        </el-table-column>

        <el-table-column
          prop="productPrice"
          :label="$t('productAdded.priceRMB')"
          min-width="10%"
          align="right"
          :formatter="productPriceFormat"
        />
        <el-table-column
          prop="productStatus"
          :label="$t('productAdded.productState')"
          min-width="12%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductStatusFomation :scope="scope.row" />
            <span v-if="scope.row.supplyStatus != null" style="color: red;">
              {{ scope.row.supplyStatus }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="powerDissipation"
          :label="$t('productAdded.powerConsumption')"
          min-width="8%"
          align="left"
        />
        <el-table-column
          prop="productType"
          :label="$t('productAdded.typAndProjectCycle')"
          min-width="10%"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.productType }}
            <span v-if="isNotNull(scope.row.productType)">
              类
            </span>
            <span v-if="isNotNull(scope.row.productType)&&isNotNull(scope.row.deliveryPeriod)">，
            </span>
            <span v-if="isNotNull(scope.row.deliveryPeriod)" :style="scope.row.deliveryPeriod>=90?{color:'red'}:''">
              {{ scope.row.deliveryPeriod }}
              天
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productPscType"
          :label="$t('productAdded.serviceClassification')"
          min-width="4%"
          align="left"
        />
        <el-table-column
          label="more"
          min-width="8%"
          align="left"
        >
          <template slot-scope="scope">
            <MoreContent :scope="scope" :is-partner="isPartner" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('productAdded.operate')"
          min-width="10%"
          align="left"
        >
          <template slot-scope="scope">
            <el-row :gutter="1">
              <el-col :span="12">
                <el-button
                  type="primary"
                  size="mini"
                  @click="doReplace(scope.row.productId,scope.row.seriesId)"
                  style="padding: 4px 8px"
                >
                  {{ $t('productAdded.replace') }}
                </el-button>
              </el-col>
              <el-col :span="12">
                <ProductOperate :scope="scope" />
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Api from '../../api';
import ProductStatusFomation from '../components/ProductStatusFomation';
import longText from '../quotationlist/longText';
import { productPriceFormat } from '@/utils/numberFormater';
import MoreContent from '../selectproduct/MoreContent';
import { isPartnerM, isNotNull } from '@/utils/mUtils';
import ProductNameFormation from '../components/ProductNameFormation';
import ProductOperate from '../components/ProductOperate';
export default {
  data () {
    return {
      subId: '',
      tableData3: [],
      hostName: '',
      groupId: '',
      projectId: '',
      screenWidth: document.body.clientWidth, // 这里是给到了一个默认值 （这个很重要）
      loading3: true,
      groupName: '',
      formInline: {
        keyWords: '',
        region: '',
        lineProperty: '',
        userCollection: ''
      },
      isService: false,
      isPartner: true,
      allLinePropertyMap: [],
      loading: false,
      propertyCode: '',
      productCode: '',
      itemId: '',
      productName: '',
      routerPath: ''
    };
  },
  components: { longText, MoreContent, ProductNameFormation, ProductOperate, ProductStatusFomation },
  methods: {
    productPriceFormat,
    isNotNull,
    save () {
      let body = {
        subId: this.subId,
        list: this.tableData3
      };
      Api.saveChoosePartList(body)
        .then(result => {
          if (result.data.status === '200') {
            this.$router.push({ name: 'AddedProduct/added',
              params: { groupId: this.groupId, projectId: this.projectId, groupName: this.groupName, propertyCode: this.propertyCode, subId: this.subId },
              query: {
                routerPath: this.routerPath
              } });
          } else {
            this.$notify.error(result.data.msg);
          }
        })
        .catch(e => {
           this.$notify.error(this.$t('productAdded.networkAnomaly'));
          console.error('e', e);
        });
    },
    getHostName () {
      Api.getHostNameBySubId(this.subId)
        .then(result => {
          if (result.data.status === '200') {
            this.hostName = result.data.data;
            if (this.hostName == null) {
              this.hostName = '暂无';
            }
          } else {
            this.$notify.error(result.data.msg);
          }
        })
        .catch(error => {
          this.$notify.error(this.$t('productAdded.networkAnomaly'));
        });
    },
    // 点击导航 产品配置
    toSecond () {
      this.$router.push({ name: 'CreatOrderSecond/second', query: { projectId: this.projectId } });
    },
    // 点击导航，已添加产品
    selectProduct () {
      this.$router.push({ name: 'AddedProduct/added',
        params: {
          groupId: this.groupId,
          projectId: this.projectId,
          propertyCode: this.propertyCode,
          groupName: this.groupName,
          isService: this.isService,
          subId: this.subId

        },
        query: {
          routerPath: this.routerPath
        } });
    },
    changText (row) {
      if (row.ifShow === undefined) {
        this.$set(row, 'ifShow', true);
      } else {
        row.ifShow = !row.ifShow;
      }
    },
    productDesc (val) {
      let cont = '';
      if (this.screenWidth <= 1440) {
        cont = val.length > 35 ? val.substring(0, 35) : val;
        return cont;
      } else {
        cont = val.length > 40 ? val.substring(0, 40) : val;
        return cont;
      }
    },
    initPartsList () {
      let param = {
        subId: this.subId,
        keyWords: this.formInline.keyWords,
        sameTypeProductCode: this.productCode,
        userCollection: this.formInline.userCollection,
        subPropertyCode: this.$route.params.subPropertyCode,
        subProductCode: this.$route.params.subProductCode,
        optionalType: this.$route.params.optionalType,
        productSeriesId: this.$route.params.productSeriesId,
        propertyCode: this.$route.params.propertyCode,
        productCode: this.$route.params.productCode
      };
      Api.getReplaceableProductList(param)
        .then(result => {
          if (result.data.status === '200') {
            this.tableData3 = result.data.data;
          } else {
            this.$notify.error(result.data.msg);
          }
        })
        .catch(e => {
          this.$notify.error(this.$t('productAdded.networkAnomaly'));
        });
      this.loading3 = false;
    },
    searchByKeyWords () {
      this.initPartsList();
    },
    checkValid (remarks) {
      return !!(remarks && remarks.trim().length > 0);
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.searchByKeyWords();
    },
    doReplace (productId, seriesId) {
      this.$confirm(this.$t('productAdded.message_009'), this.$t('productAdded.prompt'), {
        //confirm: '确定',
        // takeAway: '取消',
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading3 = true;
        let body = {
          seriesId: seriesId,
          projectId: this.projectId,
          itemId: this.itemId,
          propertyCode: this.propertyCode,
          newProductId: productId,
          groupTyp: this.getGroupType(),
          subId: this.subId
        };
        Api.replaceProduct(body).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.loading3 = false;
            this.$notify.success(this.$t('productAdded.replaceSucceeded'));
            this.selectProduct();
          }
        }).catch(e => {
          this.loading3 = false;
          this.$notify.error(this.$t('productAdded.networkAnomaly'));
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('productAdded.hasBeenDelete')
        });
      });
    },
    popoverClose (productId) {
      this.$refs[productId].doClose();
    },
    getGroupType () {
      let groupType = 1;
      if (this.isService) {
        groupType = 2;
      }
      return groupType;
    }
  },
  mounted () {
    this.isPartner = isPartnerM();
    this.subId = this.$route.params.subId;
    this.groupId = this.$route.params.groupId;
    this.projectId = this.$route.params.projectId;
    this.groupName = this.$route.params.groupName;
    this.propertyCode = this.$route.params.propertyCode;
    this.productCode = this.$route.params.productCode;
    this.itemId = this.$route.params.itemId;
    this.isService = this.$route.params.isService;
    this.productName = this.$route.params.productName;
    // console.log("this.$route.query.routerPath=",this.$route.query.routerPath);
    // console.log("tthis.$route.params=",this.$route.params);
    this.routerPath = this.$route.query.routerPath;

    this.initPartsList();// 初始化配件列表
    // this.getHostName();//获取当前主机名称

    let that = this;
    window.onresize = () => {
      return () => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      };
    };
    window.onscroll = () => {
      let height = document.documentElement.scrollTop || document.body.scrollTop;
      if (height > 95) {
        this.$refs.headtap.className = 'fixed';
        this.$refs.headtable.style.marginBottom = '150px';
      } else {
        this.$refs.headtap.className = '';
        this.$refs.headtable.style.marginBottom = '20px';
      }
    };
  },
  destroyed () {
    window.onscroll = null;
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val;
    }
  }
};
</script>

<style lang="scss">
  @import "../../styles/product-common.css";
  .replaceProductItem-css {
    .el-form-item--small .el-form-item__content{
      line-height: 40px !important;
    }
  }
  .replaceProductItem-css .select-option{
    height: 3.2rem;
    line-height: 3.2rem;
    text-align: left;
   margin: 20px 0px;
  }
  .replaceProductItem-css .table-select{
    /*margin-top: 2rem;*/
    margin-bottom: 100px;
  }
  .replaceProductItem-css .grid-content{
    float: left;
    margin-right: 20px;
  }
  .clear{
    clear: both;
  }
  .replaceProductItem-css .grid-content:last-of-type{
    margin-right: 0;
  }
  .replaceProductItem-css .select-option .grid-content:last-of-type{
    float: right;
  }
  .replaceProductItem-css .el-tag img{
    width: 24px;
  }
  .replaceProductItem-css .promotion{
    width: 30px;
  }
  .replaceProductItem-css .promotion img{
    width:auto;
    height: auto;
    vertical-align: middle;
  }

  .replaceProductItem-css .promotion:hover img{
    width: 34px;
  }
  .replaceProductItem-css  .el-breadcrumb__inner a{
    color: #36BADE;
    font-weight: normal;
  }
  @media screen and (max-width: 1366px) {
    .replaceProductItem-css table tr td{
      padding: 0;
    }
    .replaceProductItem-css .select-option{
      height: 3.2rem;
      line-height: 3.2rem;
    }
    .replaceProductItem-css .select-option{
      margin-top: 0.5rem;
    }
    .replaceProductItem-css .table-select {
      margin-top:1rem;
    }
  }

</style>
